import React, { Component } from 'react';

//React-PDF dependencies

// Spinner Imports, first way to import. This is recommended to reduce bundle size
import PropagateLoader from "react-spinners/PropagateLoader";
import BarLoader from "react-spinners/BarLoader";
import ClockLoader from "react-spinners/ClockLoader";
import ScaleLoader from "react-spinners/ScaleLoader";


const loaderStyle = {
  container: {
    paddingTop: 30,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    marginTop: 30,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
};

class CustomLoader extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _typeOfComponent = (type) => {
    switch(type) {
      case 'BarLoader':
        return <BarLoader
          height={5}
          width={150}
          color={process.env.REACT_APP_PRIMARY_COLOR}
          loading={this.state.loading}
        />
      case 'ClockLoader':
        return <ClockLoader
          size={50}
          color={process.env.REACT_APP_PRIMARY_COLOR}
          loading={this.state.loading}
        />
      case 'ScaleLoader':
        return <ScaleLoader
          size={50}
          height={35}
          width={4}
          radius={2}
          margin={2}
          color={process.env.REACT_APP_PRIMARY_COLOR}
          loading={this.state.loading}
        />
      default:
        return <PropagateLoader
          size={15}
          color={process.env.REACT_APP_PRIMARY_COLOR}
          loading={this.state.loading}
        />
    }
  }

  render(){
    return (
      <div style={loaderStyle.container}>
        {
          this._typeOfComponent(this.props.spinnerType)
        }
        <label style={loaderStyle.header}>{this.props.label}...</label>
      </div>
    );
  }
}

export default CustomLoader;



// WEBPACK FOOTER //
// src/components/innerComponents/CustomLoader.js